import { Provider } from '@angular/core';

import { EntityFormService, ValidationService } from './form/services';
import { FormFactory } from './services/form-factory.service';
import { SelectService } from '@kaiser-software/chassis-core/src/app/forms/form/services/select.service';

export {
    FormFactory,
    EntityFormService,
    ValidationService
};

export const FormServices: Provider[] = [
    FormFactory,
    EntityFormService,
    ValidationService,
    SelectService,
];



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form.services.ts